import createAction from '../services/create-action';

export const SET_TEXT_EDITOR_ENTITY_DATA = 'textEditor/SET_ENTITY_DATA';

export const setTextEditorEntityData = createAction(SET_TEXT_EDITOR_ENTITY_DATA);



// WEBPACK FOOTER //
// ./app/actions/set-text-editor-entity-data.js